module.exports = __webpack_public_path__ + "img/refresh-blue-24dp.50b5674a.svg";